<template>
  <div class="u-music">
    <div class="musicBox" @click="playBtn" :class="toShow ? '' : 'hideStyle'">
      <img src="../../assets/player.png" :class="isPlay ? 'turnRotate' : ''">
      <!-- <audio id="bgm" src="../../assets/bgm.mp3"></audio> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'u-music',
  data () {
    return {
      bgm: null,
      btn_bgm: null,
      isPlay: false,
      bgmIcon: 'https://grcbank-zs.oss-cn-shenzhen.aliyuncs.com/playing.png'
    }
  },
  props: {},
  computed: {
    toShow () {
      // console.log('改变状态')
      return this.$store.state.showMusic
    }
  },
  mounted () {
    console.log(mapState)
    // this.bgm = document.getElementById('bgm')
    // bgm
    const bg_music = require('../../assets/bgm.mp3')
    this.bgm = new Audio(bg_music)
    // 音效
    const mp3 = require('../../assets/btn_music.mp3')
    this.btn_bgm = new Audio(mp3)
  },
  methods: {
    toPlay () {
      if (!this.isPlay) {
        this.playBtn()
      }
    },
    playBtn () {
      console.log('现在正在播放？', this.bgm, this.isPlay)
      if (!this.isPlay) {
        this.prePlay(0)
        this.bgm.play()
        this.isPlay = true
        this.bgm.loop = true
        this.bgmIcon = 'https://grcbank-zs.oss-cn-shenzhen.aliyuncs.com/playing.png'
        this.$stat({
          event: 'on_bgm' // 上报埋点信息
        })
      } else {
        this.bgm.pause()
        this.isPlay = false
        this.bgmIcon = 'https://grcbank-zs.oss-cn-shenzhen.aliyuncs.com/pause.png'
        this.$stat({
          event: 'close_bgm' // 上报埋点信息
        })
      }
    },
    prePlay (val) {
      if (val) {
        this.bgm.muted = true
        this.bgm.play()
        this.btn_bgm.muted = true
        this.btn_bgm.play()
      } else {
        this.bgm.muted = false
        this.bgm.pause()
      }
    },
    playBtnBgm () {
      this.btn_bgm.muted = false
      this.btn_bgm.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.u-music{
}
.musicBox{
  position: absolute;
  top: 18px;
  // transform: translateY(40%);
  right: 4.7%;
  width: 11.5%;
  height: auto;
  // z-index: 2;
  img{
    width: 100%;
    height: auto;
    pointer-events: none;
  }
  .turnRotate{
    animation: turnRotate 1.5s infinite linear;
  }
}
@keyframes turnRotate{
  0%{
    transform:rotate(0deg);
  }
  100%{
    transform:rotate(360deg);
  }
}
.hideStyle{
  opacity: 0;
  z-index: -1;
}
</style>
